import { lazy } from 'react';
function lazyWithPreload(factory) {
  const Component = /*#__PURE__*/lazy(factory);
  Component.preload = factory;
  return Component;
}
export const workflowsRegistryEntry = {
  namespace: 'WORKFLOWS',
  components: {
    PLAN_REVIEW: lazyWithPreload(() => import( /* webpackChunkName: "workflows-components" */'./PlanReviewCard'))
  }
};